<template>
  <div class="group">
    <div class="page-title">{{ $t("lang.title_group") }}</div>
    <ATable
      ref="table"      
      max-height="750px"
      :data="items"
      :loading="loading"
      :search_field="search_field"
      :placeholder="placeholder"
      :disable_insert="!has_grant_write"
      hide-pagination
      border
      @row-click="handleClickRow"
      @clicked-create="handleClickedCreate"
    >
        <el-table-column 
          type="index" 
          label="No" 
          :index="handleIndex" 
          :width="$width.index"
        />
        <el-table-column 
          prop="name" 
          :label="$t('lang.user_group')" 
        />
        <el-table-column 
          width="100"
          class-name="cell-number"
          :label="$t('lang.login_users')"  
          :formatter="util.numberFormat" 
        >
          <template slot-scope="scope">
            {{ displayUserCount(scope.row.id)}}
          </template>
        </el-table-column>
        <el-table-column 
          prop="desc" 
          :label="$t('lang.notes')"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
    </ATable>
    <el-dialog
      top="0"
      custom-class="form-dialog"
      destroyOnClose
      :title="$t('lang.title_group')"
      :visible.sync="dialogVisible"      
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <GroupForm
        ref="form"
        v-if="dialogVisible"
        :data="form_data"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import GroupForm from "./GroupForm";

export default {
  name: "Group",
  mixins: [form_container, authority_level],
  components: {
    GroupForm
  },
  data() {
    return {
        dialogVisible: false,
        loading: false,
        items: [],
        form_data: undefined,
        search_field: ['name', 'desc'],
        placeholder: this.$t('lang.user_group') + ", " + this.$t('lang.notes')
    };
  },
  computed: {
    ...mapGetters(["table_user", "table_user_group"]),
    has_grant_write() {      
      return this.isWriteLevel('group');
    },
  },
  created() {
    this.items = this.table_user_group;
  },
  methods: {
    handleClickRow(data) {
      this.openDialog(data);
    },
    /**Open dialog boxes */
    openDialog(data) {
      let clone = data ? this.util.looseClone(data) : undefined;
      this.form_data = clone;
      this.dialogVisible = true;
      // this.$nextTick(() => this.$refs.form.init());
    },
    /**Data numbering */
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    /** Click the Add button to open the dialog box*/
    handleClickedCreate() {
      this.openDialog();
    },
    displayUserCount(group_id) {
        let data = this.table_user.filter(u => u.user_group_id === group_id);
        return data.length;
    },
    handleCompleted(message) {
      this.dialogVisible = false;
      this.items = this.table_user_group;
      this.form_data = undefined;
      if (!message) { return; }
      this.$notify(message);
    },
  }
};
</script>
